/**
 * TutorApplicationIntroScreen — l'intro du champion d'une étape de la candidature (la route `intro`,
 * pour le candidat seulement : l'élève et le visiteur gardent l'ancien `ChampionIntroScreen`). Un
 * fil : l'état (`useTutorApplicationIntroState`), la page du DS.
 */
import React from "react"

import { TutorApplicationIntroPage } from "../../../../../../design-system/tutor"
import { type TutorSpaceScreenProps } from "../tutorSpaceRouteTypes"
import { type ApplicationIntroParams, useTutorApplicationIntroState } from "./useTutorApplicationIntroState"

export function TutorApplicationIntroScreen(props: TutorSpaceScreenProps) {
    const intro = useTutorApplicationIntroState((props.route?.params ?? {}) as ApplicationIntroParams)
    return <TutorApplicationIntroPage {...intro} testID="tutor-application-intro" />
}
